export default __webpack_public_path__ + "static/media/efficiency.0366241c.svg";